import { expiryStatus, EXPIRY_CLS } from "@/lib/expiry";

export function ExpiryBadge({ expiryDate, thresholds, className = "", testId }) {
  const s = expiryStatus(expiryDate, thresholds);
  return (
    <span data-testid={testId} className={`inline-block rounded-full border px-2 py-0.5 text-[10px] font-semibold ${EXPIRY_CLS[s.code]} ${className}`}>
      {s.label}
    </span>
  );
}
